import React, { useState } from "react";
import { useAutoFocus } from "../../../../../hook/useAutoFocus";
import { useCreateSensorGroupMutation } from "../../../component/SensorGroups.generated";
import { TreeNode } from "./TreeNode";

interface Props<T> {
  node?: TreeNode<T>;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export const NewSensorGroupInput = <T extends unknown>({
  node,
  onSuccess = () => {},
  onCancel = () => {},
}: Props<T>) => {
  const [groupName, setGroupName] = useState("");
  const [createSensorGroup] = useCreateSensorGroupMutation({
    variables: { name: groupName, parent: node?.id },
    refetchQueries: ["SensorGroups"],
  });

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (groupName.trim() === "") {
      return;
    }
    createSensorGroup().then();
    setGroupName("");
    onSuccess();
  };

  const inputRef = useAutoFocus();

  return (
    <form className="ml-3 mr-10" onSubmit={handleSubmit}>
      <input
        placeholder={"Enter group name"}
        className="w-full outline-none"
        ref={inputRef}
        value={groupName}
        onChange={(event) => setGroupName(event.target.value)}
        onBlur={() => onCancel()}
        onKeyUp={(event) => event.key === "Escape" && onCancel()}
      ></input>
    </form>
  );
};
